import BUY_SKIN from "@assets/images/widgets/acheter-un-compte-skin-niveau-30.png";
import ButtonVariants from "@core-components/button/ButtonVariants";
import Icon from "@core-components/icon/Icon";
import ProductDetailLine from "@core-components/product-detail-line/ProductDetailLine";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import { Badge, Card, Group } from "@mantine/core";
import { IconBolt } from "@tabler/icons-react";

const BuySkinWidget: React.FC = () => {
  const { locationUrlBuilder } = useAppLanguage();

  return (
    <Card
      withBorder
      className="hover-scale"
      classNames={{
        root: "bg-primary-default border-primary-lighter max-w-[800px] md:p-5 background-image-[var(--image-url)]",
      }}
      padding="xs"
      radius="md"
      shadow="sm"
      styles={{
        root: {
          "--image-url": `url(${BUY_SKIN})`,
        } as React.CSSProperties,
      }}
    >
      <div className="flex w-full flex-col md:flex-row">
        <div className="">
          <Badge
            classNames={{
              label: "text-gradient-green font-inter",
            }}
            color="#4B865Fa2"
            radius="md"
            size="xl"
            variant="filled"
          >
            NOUVEAU !
          </Badge>
          <p className="my-4 font-inter text-primary-light-text">
            Choisissez votre nouveau compte lol en fonction du skin ! Vous êtes
            un OTP ou vous souhaitez un skin en particulier ?
          </p>
          <ButtonVariants.Gradient
            isFullWidth
            className="hover-scale hidden rounded-md md:block"
            href={locationUrlBuilder(EPublicRoutes.SMURFS_SKIN)}
            label={
              <Group justify="center">
                <Icon.AddToBasket size={20} />
                Trouve un skin
              </Group>
            }
          />
        </div>
        <div className="md:flex md:w-1/2 md:min-w-[325px] md:flex-col md:justify-between md:self-stretch md:px-4">
          <ProductDetailLine
            color="#00B61D"
            description={""}
            icon={IconBolt}
            label="Level 30+"
          />
          <ProductDetailLine
            color="#00B61D"
            description={""}
            icon={IconBolt}
            label="Livraison instantanée !"
          />
          <ProductDetailLine
            color="#00B61D"
            description={""}
            icon={IconBolt}
            label="Email et mot de passe modifiables"
          />
          <ProductDetailLine
            color="#00B61D"
            description={""}
            icon={IconBolt}
            label="Toutes saisons non classées"
          />
        </div>
      </div>
      <ButtonVariants.Gradient
        className="hover-scale mt-4 rounded-md md:hidden"
        href={locationUrlBuilder(EPublicRoutes.SMURFS_SKIN)}
        label={
          <Group justify="center">
            <Icon.AddToBasket size={20} />
            Trouve un skin
          </Group>
        }
      />
    </Card>
  );
};

export default BuySkinWidget;
